module.exports = __webpack_public_path__ + "media/images/icon__info--rb-gray-b4be30b2c5a939afe739404cd1dd71b3.png";